import React from 'react';
import DashboardLayout from '../Common/Layouts/DashboardLayout';
import UserDirectoryBox from './UserDirectoryBox';
import SeoMeta from '../../SEO/SeoMeta';

export default function UserDirectoryDashboardPage() {
  return (
    <>
      <SeoMeta 
        title="User Directory — Million2Trillion (M2T)" 
        description="Browse the full verified directory of market professionals on Million2Trillion. Discover traders, investors, educators, coders, brokers, legal experts, and more." 
        url="https://million2trillion.com/dashboard/directory" 
      />

      <DashboardLayout>
        <div className="space-y-6">
          <h1 className="text-xl font-bold">📁 Directory</h1>
          <UserDirectoryBox />
        </div>
      </DashboardLayout>
    </>
  );
}
